var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_PointLayerGroup = function (in_implements, in_extends, options) {
    // Need to extend the existing add layers feature
    var class_definition = OCS.Viewer.Functions.define_layer_group(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "PointLayerGroup",
        style_manager_class: OCS.Viewer.Functions.define_ol_style_manager([new Class(OCS.Viewer.Interfaces.OlPointStyle)])
    });
};
